import { useState } from "react";
import { Box, Typography, Grid, TextField, Paper, Alert } from "@mui/material";
import AppButton from "../../components/shared/AppButton/AppButton";
import AppBreadcrumbs from "../../components/shared/Breadcrumbs/AppBreadcrumbs";
import axios from "axios";
import { ENV } from "../../config/env";
import Swal from "sweetalert2";
import AppLoader from "../../components/common/Loader";


const SubmitGrievance = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
  });

  const [errors, setErrors] = useState({});
  const [submittedData, setSubmittedData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ---------------- VALIDATION ----------------
  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = "Enter valid 10-digit mobile number";
    }

    if (!formData.description.trim()) {
      newErrors.description = "Grievance description is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ---------------- HANDLERS ----------------
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);

    try {
      const response = await axios.post(
        `${ENV.API_BASE_URL}/api/grievances`,
        // "http://localhost:1338/api/grievances",
        {
          data: {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            description: formData.description,
            grievanceStatus: "Pending",
          },
        }
      );

      console.log("Saved to DB:", response.data);

      Swal.fire({
        title: "Success!",
        text: "Your grievance has been submitted successfully.",
        icon: "success",
        confirmButtonColor: "#1E3A8A",
      });


      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        description: "",
      });

    } catch (error) {
      console.error("Error saving grievance:", error);
      Swal.fire({
        title: "Submission Failed",
        text: "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
    finally {
      setLoading(false);
    }
  };

  // ---------------- UI ----------------
  return (
    <>
     <AppLoader open={loading} />
      <Box sx={{ px: { xs: 2, md: 4 }, py: 4 }}>
        <AppBreadcrumbs />
        <Grid container justifyContent="center">
          {/* Responsive wrapper */}
          <Grid item xs={12} md={8} lg={6}>
            <Paper sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
              {/* Title */}
              <Typography variant="h5" fontWeight={600} mb={1}>
                Submit a Grievance
              </Typography>

              {/* Subtitle */}
              <Typography color="text.secondary" mb={3}>
                Please provide your details and describe your grievance. You will
                receive a unique ID to track your submission.
              </Typography>

              {/* FORM */}
              <Grid container spacing={3}>
                {/* Name */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Your Name *"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    placeholder="Enter your full name"
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Your Email *"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    placeholder="your.email@example.com"
                  />
                </Grid>

                {/* Phone */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Your Phone Number *"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    error={!!errors.phone}
                    helperText={errors.phone}
                    placeholder="10-digit mobile number"
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>

                {/* Description */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Grievance Description *"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    error={!!errors.description}
                    helperText={errors.description}
                    placeholder="Please describe your grievance in detail..."
                  />
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12}>
                  <AppButton
                     label={loading ? "Submitting..." : "Submit"}
                    fullWidth
                    onClick={handleSubmit}
                    sx={{
                      py: 1.3,
                      fontSize: "1rem",
                      background: "linear-gradient(90deg, #000000, #1f2937)",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default SubmitGrievance;
